import { useState, useEffect, } from 'react';
import { callServerToGetUrls, processItems, converItemsToProGalleryItems, } from './itemsProcessor';
export var useItems = function (items, itemsSrc) {
    var _a = useState(processItems(converItemsToProGalleryItems(items, itemsSrc)).items), itemsToRender = _a[0], setItemsToRender = _a[1];
    useEffect(function () {
        var result = processItems(converItemsToProGalleryItems(items || [], itemsSrc));
        var shouldFetchVideoUtlsFromVideoSDK = result.shouldGetVideoUrls;
        setItemsToRender(result.items);
        if (shouldFetchVideoUtlsFromVideoSDK) {
            callServerToGetUrls({ newItems: converItemsToProGalleryItems(items, itemsSrc) }, setItemsToRender);
        }
    }, [items]);
    return {
        itemsToRender: itemsToRender,
    };
};
//# sourceMappingURL=itemsHelper.js.map